import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "value",
      description: "绑定的值"
    },
    {
      prop: "size",
      description: "大小 mini/small/default/middle/large",
      type: "String",
      default: "default"
    },
    {
      prop: "disabled",
      description: "是否禁用",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "theme",
      description: "主题 dark light background shadow",
      type: "String",
      default: "dark"
    },
    {
      prop: "validator",
      description: "数字校验",
      type: "Function"
    },
    {
      prop: "formatter",
      description: "显示样式",
      type: "Function",
      default: `(val)=>val?.toLocaleString(undefined, {
          maximumFractionDigits: 2
        });`
    },
    {
      prop: "interval",
      description: "箭头一次变化的间隔",
      type: "Number",
      default: "1"
    }
  ],
  events: [
    {
      name: "change",
      description: "值改变事件，在input事件之后",
      argument: "value"
    }
  ],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
